import React, { Component } from "react";
import { compose, graphql } from "react-apollo";

import Queries from "../../queries/queries2";
import SimpleSelect from "../../elements/CustomSelect/SimpleSelect";
import { injectIntl } from "react-intl";

class ClientProjectSelect extends Component {
  constructor() {
    super();
    this.state = { clientsAndProjects: [] };
  }
  getData = async () => {
    let projectOptions = [];
    let clientOptions = [];

    if (this.props.showClient !== false) {
      this.props.getAllClientsQuery.company &&
        this.props.getAllClientsQuery.company.tierses.map(tiers => {

          if (
            this.props.excludedId === undefined ||
            (this.props.excludedId && this.props.excludedId.includes(tiers.id) === false)
          ) {
            const clientOrProject = {
              value: tiers.id,
              label: tiers.name,
              type: "client"
            };
            clientOptions.push(clientOrProject);
            return clientOrProject;
          }
          else return null;
        });
    }

    if (this.props.showProject !== false) {
      this.props.getAllProjectsQuery.company &&
        this.props.getAllProjectsQuery.company.projects.map(project => {

          if (
            this.props.excludedId === undefined ||
            (this.props.excludedId && this.props.excludedId.includes(project.id) === false)
          ) {
            const clientOrProject = {
              value: project.id,
              label: project.name,
              type: "project"
            };
            projectOptions.push(clientOrProject);
            return clientOrProject;
          }
          else return null;
        });
    }

    let options = [];
    if (projectOptions.length > 0) {
      options.push({
        label: this.props.intl.formatMessage({ id: `ids_projects` }),
        options: projectOptions
      });
    }
    if (clientOptions.length > 0) {
      options.push({
        label: this.props.intl.formatMessage({ id: `ids_clients` }),
        options: clientOptions
      });
    }
    this.setState({
      clientsAndProjects: options
    });
  };
  componentDidMount() {
    this.getData();
  }
  componentDidUpdate(prevProps) {
    const { getAllProjectsQuery, getAllClientsQuery } = this.props;
    if (
      getAllProjectsQuery.company &&
      getAllClientsQuery.company &&
      getAllProjectsQuery.company.projects &&
      getAllClientsQuery.company.tierses &&
      (prevProps.getAllProjectsQuery !== getAllProjectsQuery ||
        prevProps.getAllClientsQuery !== getAllClientsQuery)
    ) {
      this.getData();
    }
  }
  render() {
    // console.log("ClientProjectSelect value", this.props.value)
    // console.log("ClientProjectSelect options", this.state.clientsAndProjects)
    return (
      <SimpleSelect
        disabled={this.props.disabled}
        name="clientOrProject"
        value={this.props.value}
        onSelected={this.props.onSelected}
        options={this.state.clientsAndProjects}
        creatable={this.props.creatable}
      />
    );
  }
}

export default compose(
  graphql(Queries.GET_ALL_CLIENTS, { name: "getAllClientsQuery" }),
  graphql(Queries.getCompanyProjectsForProjectSettings, {
    name: "getAllProjectsQuery"
  })
)(injectIntl(ClientProjectSelect));
